import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { GenericDescriptionList } from 'web-ui-components/lib/data/lists';
import { Inline } from 'web-ui-components/lib/layout/grids';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { Form } from 'react-final-form';
import AccountDetailsGroup from '../accountDetailsSection/components/AccountDetailsGroup';
import {
  PAYMENT_TRANSFER,
  resetPreviousPaymentTransfer
} from '../accountDetailsSection/accoundDetailsUtil';
import { convertToCamelCase } from '../../utils/validation';
import { content } from '../../infrastructure/content/selectors';

class AccountDetailsAccordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isEdit: false };
    this.saveDetailsForm = this.saveDetailsForm.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
  }
  handleEditClick() {
    resetPreviousPaymentTransfer(get(this.props, 'getBusinessData.accountDetailsPayment', ''));
    this.setState({ isEdit: !this.state.isEdit });
    this.props.editClick(!this.state.isEdit);
    this.props.onValueChanges(false);
  }
  saveDetailsForm(e) {
    const { saveDetailsForm, editClick, onValueChanges } = this.props;
    saveDetailsForm(e);
    this.setState({ isEdit: !this.state.isEdit });
    editClick(!this.state.isEdit);
    onValueChanges(true);
  }
  renderContentType(values, pristine) {
    const {
      getBusinessData,
      getPaymentTypeCheckboxValue,
      bankId,
      onAccountDetailsChange,
      onCountryRemove,
      externalContent
    } = this.props;
    const typeOfAccounts =
      getBusinessData && getBusinessData.paymentOfType ? getBusinessData.paymentOfType.join() : '';
    const {
      approximateAnnualTurnOver,
      typeOfAccountsWillGoThrough,
      paymentsToBeMade,
      internationalPayments,
      countriesWillSendPaymentTo,
      countriesWillRecieveMoney
    } = externalContent;
    const getAccountDetailsItem = () => {
      let accountDetailsList = [
        {
          key: approximateAnnualTurnOver,
          value: getBusinessData && getBusinessData.annualTurnover
        },
        { key: typeOfAccountsWillGoThrough, value: typeOfAccounts },
        {
          key: paymentsToBeMade,
          value: getBusinessData && convertToCamelCase(getBusinessData.howPaymentMade)
        },
        {
          key: internationalPayments,
          value: getBusinessData && getBusinessData.accountDetailsPayment
        }
      ];
      if (isValidPaymentTransfer(getBusinessData, PAYMENT_TRANSFER.MAKE_PAYMENTS)) {
        accountDetailsList = [
          ...accountDetailsList,
          {
            key: countriesWillSendPaymentTo,
            value:
              getBusinessData &&
              getBusinessData.send_payments.map(country => Object.keys(country)[0]).join(', ')
          }
        ];
      }
      if (isValidPaymentTransfer(getBusinessData, PAYMENT_TRANSFER.RECEIVE_PAYMENTS)) {
        accountDetailsList = [
          ...accountDetailsList,
          {
            key: countriesWillRecieveMoney,
            value:
              getBusinessData &&
              getBusinessData.receive_payments.map(country => Object.keys(country)[0]).join(', ')
          }
        ];
      }
      return accountDetailsList;
    };
    if (!this.state.isEdit) {
      return <GenericDescriptionList items={getAccountDetailsItem()} />;
    }
    return (
      <AccountDetailsGroup
        bankId={bankId}
        getBusinessData={values}
        getPaymentTypeCheckboxValue={getPaymentTypeCheckboxValue}
        reviewFlag={true}
        onAccountDetailsChange={onAccountDetailsChange}
        pristine={pristine}
        values={values}
        onCountryRemove={onCountryRemove}
      />
    );
  }

  render() {
    const {
      getBusinessData,
      onAccountDetailsChange,
      linkCode,
      externalContent: { changesNotSaved, confirmChanges }
    } = this.props;
    return (
      <div>
        <Form
          onSubmit={this.saveDetailsForm}
          initialValues={getBusinessData}
          render={({ handleSubmit, values, pristine }) => (
            <form
              onSubmit={handleSubmit}
              onChange={e => {
                if (
                  getBusinessData &&
                  Object.values(getBusinessData).join('') &&
                  e.target.name !== 'businessType-group'
                )
                  onAccountDetailsChange(e);
              }}
            >
              {this.renderContentType(values, pristine)}
              {this.state.isEdit && (
                <div>
                  <ActionButton.Primary
                    labelText={confirmChanges}
                    onClick={() => this.updateAccordionForm}
                  />
                  <p>{changesNotSaved}</p>
                </div>
              )}
              {!linkCode && (
                <Inline.LeftAligned
                  nodes={[
                    <NavigationButton.Tertiary
                      labelText={this.state.isEdit ? 'Cancel Editing' : 'Edit'}
                      onClick={this.handleEditClick}
                    />
                  ]}
                />
              )}
            </form>
          )}
        />
      </div>
    );
  }
}

const isValidPaymentTransfer = (getBusinessData, condition) =>
  getBusinessData &&
  (getBusinessData.accountDetailsPayment === condition ||
    getBusinessData.accountDetailsPayment === PAYMENT_TRANSFER.MAKE_AND_RECEIVE_PAYMENTS);

const mapStateToProps = state => ({
  externalContent: content(state)
});
export default connect(mapStateToProps, null)(AccountDetailsAccordion);
